import { ReferAFriend } from "../components/refer-a-friend";

const test = ({
  __typename,
  staticType,
}: {
  __typename: string;
  staticType: string;
}): boolean =>
  __typename === "VinoData_StaticBlock" && staticType === "Refer a Friend";

const create = (): JSX.Element => {
  return <ReferAFriend />;
};

export default { test, create };
